import { createSlice } from "@reduxjs/toolkit";
import { brandEdit } from "./brandAsyncThunk";

const brandEditSlice = createSlice({
  name: "brand",
  initialState: {
    isLoading: false,
    isSuccess: false,
    failCode: 0,
    failMessage: "",
  },
  reducers: {},
  extraReducers: {
    [brandEdit.pending]: (state, action) => {
      state.isLoading = true;
      state.isSuccess = false;
      state.failCode = 0;
    },
    [brandEdit.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = true;
    },
    [brandEdit.rejected]: (state, action) => {
      state.isLoading = false;
      state.failCode = action.payload.status;
      state.failMessage = action?.payload?.data?.message;
    },
  },
});

export default brandEditSlice.reducer;
